<div [class]="isVerticalLayout$ | async" class="h-full w-full px-0">
  <button
    (click)="closemail()"
    class="mail-close-toggle"
    color="primary"
    title="Close"
    mat-icon-button
    type="button">
    <mat-icon svgIcon="mat:close"></mat-icon>
  </button>

  <mat-progress-bar *ngIf="mailService.loading | async" mode="indeterminate"></mat-progress-bar>

  <mat-drawer-container class="h-full w-full">
    <mat-drawer
      #drawer
      [(opened)]="drawerOpen"
      [disableClose]="(isDesktop$ | async) ?? true"
      [mode]="(drawerMode$ | async) ?? 'side'"
      class="vex-mail-drawer max-w-3xs w-full bg-base"
      position="start">
      <div class="vex-mail-header bg-primary-600/10 px-6 relative flex flex-col justify-center">
        <div *ngIf="isDesktop$ | async" class="flex-1 flex items-center">
          <p class="text-2xl font-medium flex items-center">
            <mat-icon @scaleIn class="ltr:mr-4 rtl:ml-4 block icon-2xl" svgIcon="mat:mail"></mat-icon>
            <span @fadeInRight class="block">Mailbox</span>
          </p>
        </div>

        <div class="vex-mail-header-overflow flex-none flex items-center">
          <button (click)="openCompose()" class="w-full" color="primary" mat-raised-button type="button">
            Compose
          </button>
        </div>
      </div>

      <vex-mail-sidenav [drawer]="drawer"></vex-mail-sidenav>
    </mat-drawer>

    <mat-drawer-content class="bg-base flex flex-col overflow-hidden">
      <div class="vex-mail-header flex-none bg-primary-600/10 flex flex-col">
        <div class="flex-auto flex items-center gap-3 px-6">
          <button (click)="drawer.open()" class="lg:hidden" mat-icon-button type="button">
            <mat-icon svgIcon="mat:menu"></mat-icon>
          </button>

          <mat-form-field appearance="outline" class="w-72" subscriptSizing="dynamic">
            <mat-label>Email account</mat-label>
            <mat-select
              [value]="mailService.selectedAccountId | async"
              (selectionChange)="mailService.selectAccount($event.value)">
              <mat-option *ngFor="let account of mailService.accounts | async" [value]="account.id">
                {{ account.emailaddress }} ({{ account.accounttype }})
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="flex-1" subscriptSizing="dynamic">
            <mat-icon matIconPrefix svgIcon="mat:search"></mat-icon>
            <input [formControl]="searchCtrl" class="bg-foreground" matInput placeholder="Search mails..." type="text" />
          </mat-form-field>

          <button
            (click)="mailService.syncCurrentAccount()"
            [disabled]="mailService.syncing | async"
            color="primary"
            mat-icon-button
            matBadgeColor="accent"
            matTooltip="Fetch new mails"
            type="button">
            <mat-icon svgIcon="mat:sync"></mat-icon>
          </button>
        </div>

        <div class="vex-mail-header-overflow flex-none px-6 flex items-center text-sm text-secondary">
          <span>{{ mailService.selectedFolder | async }}</span>
          <span class="mx-2">•</span>
          <span>Total {{ mailService.total }}</span>
          <span class="mx-2">•</span>
          <span>Unread {{ mailService.unread }}</span>
          <span *ngIf="mailService.syncing | async" class="ml-4">Fetching new mail...</span>
        </div>
      </div>

      <div
        [ngClass]="{
          'ltr:mr-6 rtl:ml-6 mb-6': isDesktop$ | async
        }"
        class="vex-mail-content-overflow flex-auto bg-foreground rounded shadow flex flex-col overflow-hidden">
        <vex-mail-list></vex-mail-list>
      </div>
    </mat-drawer-content>
  </mat-drawer-container>

  <div class="gmail-compose-stack">
    <vex-mail-compose
      *ngFor="let compose of composeWindows; trackBy: trackComposeWindowId"
      [account]="selectedAccount()"
      [draft]="compose.draft || null"
      [mail]="compose.mail"
      [maximized]="compose.maximized"
      [minimized]="compose.minimized"
      [mode]="compose.mode"
      [storageKey]="'mail-compose-' + compose.id"
      (close)="closeCompose(compose.id)"
      (discard)="closeCompose(compose.id)"
      (maximizeChange)="toggleComposeMaximize(compose.id, $event)"
      (minimizeChange)="toggleComposeMinimize(compose.id, $event)"></vex-mail-compose>
  </div>
</div>
